const isDev = (document.domain === 'ohm.dev.opoint.com')

export const log = (...args) => {
  if (document && isDev) {
    // eslint-disable-next-line
    console.log(...args)
  }
}

export const debug = (...args) => {
  if (document && isDev) {
    // eslint-disable-next-line
    console.debug(...args)
  }
}
